export const sortDateByDate = (data, sortBy) => {
  let arr = data.sort((a, b) => {
    return b[sortBy] - a[sortBy];
  });
  //remove duplicate data
  return arr.filter((v, i, a) => a.findIndex(t => t.Id === v.Id) === i);
};
